import { render } from "./App.vue?vue&type=template&id=8cee0224"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alejandropascual/Websites/_CODEABLE/Task-171603-Beat/wordpress/wp-content/plugins/aps-modul-booking/_vue/shortcode_modul_courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__